import 'bootstrap';
import 'popper.js';
import $ from 'jquery';
import { TOGGLE_FAVOURITE } from './bitrix-bridge/addFavourite';

/** @this {HTMLButtonElement} */
function getTitle() {
	const isActive = this.classList.contains('active');

	if (isActive)
		return this.dataset.titleActive;
	else
		return this.dataset.titleInactive;
}

/** @this {HTMLButtonElement} */
function updateTooltip() {
	$(this).tooltip('hide');
}

/** @this {Element} element */
function ProductCardFavourite() {
	$(this)
		.tooltip({
			title: getTitle
		})
		.on(TOGGLE_FAVOURITE, updateTooltip);
}

$(() => $('.product-card-favourite button').each(ProductCardFavourite));

export { ProductCardFavourite };
